import React from "react";
import { render } from "react-dom";
import App from "./App";
import 'react-toastify/dist/ReactToastify.css'

render(<App />, document.getElementById("root"));
